// eslint-disable-next-line no-use-before-define
import React, { useEffect, useRef } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import '@cora/hercules-site-sidemenu-component';
export const MenuV1Component = (props) => {
    const { mainMenu, iconUrl, hidden, navigate, logout, currentPath, uiVersion, } = props;
    const normalizeMenuItems = (_items, level = 0) => {
        if (!_items)
            return [];
        return _items.map(({ title, children, target, icon, ...rest }) => ({
            opened: false,
            level,
            label: title,
            path: rest.path,
            icon: `${iconUrl}/${icon}`,
            target: target === 'blank' ? '_blank' : '_self',
            children: children.length && normalizeMenuItems(children, level + 1),
        }));
    };
    const ref = useRef();
    const onItemSelect = (e) => {
        navigate(e.detail.path);
    };
    useEffect(() => {
        if (ref.current) {
            ref.current.addEventListener('on-item-selected', onItemSelect);
            ref.current.addEventListener('on-logout', logout);
        }
        return () => {
            if (ref.current) {
                ref.current.removeEventListener('on-item-selected', onItemSelect);
                ref.current.removeEventListener('on-logout', logout);
            }
        };
    }, [uiVersion]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `root-app_menu menu-v1 ${hidden ? 'hidden' : ''}` },
            React.createElement("her-side-menu", { ref: ref, collapsed: "true", currentPath: currentPath, items: mainMenu ? JSON.stringify(normalizeMenuItems(mainMenu)) : '[]' }))));
};
//# sourceMappingURL=component.js.map